module.exports = __webpack_public_path__ + "img/chris (23).cbc3d8fc.jpg";